import { Component, OnInit } from '@angular/core';
import { MockupPreviewComponent } from '../mockup-preview/mockup-preview.component';
import { PhotosService } from '../services/photos.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
    selector: 'app-app-ui',
    templateUrl: './app-ui.component.html',
    styleUrls: ['./app-ui.component.css']
})
export class AppUiComponent implements OnInit {

    appUi = [];

    constructor(private photos: PhotosService, public dialog: MatDialog) { }
    
    ngOnInit() {
        this.appUi = this.photos.appUi;
    }

    openDialog(url: string): void {
        if (screen.width > 600) {
            this.dialog.open(MockupPreviewComponent, {
                maxHeight: '90%',
                width: '1000px',
                data: {url: url}
            });
        }
    }

}
